/* eslint-disable no-bitwise */

export const defaultLink = '/placements';

export const hashCode = s => s.split('').reduce((a, b) => {
  const c = ((a << 5) - a) + b.charCodeAt(0);
  return c & c;
}, 0);
